export default __webpack_public_path__ + "33038bf3b4c8b6c1d0e63bc1194fbd01.svg";